// extracted by mini-css-extract-plugin
export default {"secondList":"DropdownList_secondList__fXcna"};